import { GlobalWorkerOptions, version as pdfjsApiVersion } from 'pdfjs-dist';
import { SYNCED_PDFJS_WORKER_VERSION } from './workerVersion';

const PDF_WORKER_SRC = '/pdf.worker.min.mjs';

let isWorkerInitialized = false;

export const initPdfJsWorker = () => {
  if (isWorkerInitialized) {
    return;
  }

  GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC;

  if (
    process.env.NODE_ENV !== 'production' &&
    SYNCED_PDFJS_WORKER_VERSION &&
    pdfjsApiVersion !== SYNCED_PDFJS_WORKER_VERSION
  ) {
    console.warn(
      `[pdfjs] API/worker version mismatch detected. API=${pdfjsApiVersion}, syncedWorker=${SYNCED_PDFJS_WORKER_VERSION}. Run 'npm run sync:pdf-worker'.`
    );
  }

  isWorkerInitialized = true;
};
